export const updateRespondDetails = (type, details) => ({
  type: type,
  //"UPDATE_RESPONDED_DETAILS",
  payload: details,
});

export const updateothereRespondedDetails = (type, details) => ({
  type: type,
  //"UPDATE_OTHER_RESPONDED_DETAILS",
  payload: details,
});

export const updateCompletionInfoDetails = (type, details) => ({
  type: type,
  //"UPDATE_COMPLETION_DETAILS",
  payload: details,
});

export const addRepairTrackerForVendor = (type, details) => ({
  type: type,
  //"ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
  payload: details,
});

export const updateRepairTrackerForVendor = (type, details) => ({
  type: type,
  //"UPDATE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
  payload: details,
});

export const addPartReplacementDetailsForVendor = (type, details) => ({
  type:type,
  //"PART_REPLACEMENT_FOR_VENDOR",
  payload: details,
});

export const updatePartReplacementDetailsForVendor = (type, details) => ({
  type: type,
  //"UPDATE_PART_REPLACEMENT_FOR_VENDOR",
  payload: details,
});

export const clearPartRepalacementForVendor = (type, details) => ({
  type: type,
  //"CLEAR_PART_REPLACEMENT_FOR_VENDOR",
  payload: details,
});

export const deleteRepairTrackerForVendor = (type, details) => ({
  type: type,
  //"DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR",
  payload: details,
});

export const clearRepairTrackerForVendor = (type, details) => ({
  type: type,
  //"CLEAR_REPAIR_TRACKER_FOR_VENDOR",
  payload: details,
});


export const checkFormSubmitForVendor = (type, details) => ({
  type: type,
  //"UPDATE_FORMSUBMIT_STATUS",
  payload: details,
});

export const clearWebForm = (type, details) => ({
  type: type,
  //"CLEAR_WEB_FORM",
  payload: details,
});

export const getWebFormVendorName = (type, details) => ({
  type: type,
  //"GET_WEBFORM_VENDORNAME",
  payload: details,
});
